import { gql } from '@apollo/client';

export const UPDATE_AUXILIARY_WA_STATUS = gql`
	mutation UpdateAuxiliaryWorkAssignmentStatus($input: WorkAssignmentStatusUpdateInput!) {
		updateAuxiliaryWorkAssignmentStatus(input: $input) {
			... on WorkAssignmentAuxiliaryMutationErrorResponse {
				errors
				__typename
			}
			... on WorkAssignmentAuxiliaryMutationSuccessResponse {
				workAssignment {
					id
					version
					fromTimestamp
					fromStation {
						id
						name
					}
					toStation {
						id
						name
					}
					crewMember {
						id
						fullName
					}
				}
			}
			... on WorkAssignmentOverlappingActivitiesResponse {
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							activityType
							fromStation {
								name
								code
								timezone
								city {
									name
								}
							}
							toStation {
								name
								code
								timezone
								city {
									name
								}
							}
						}
						... on CrewMemberAbsenceActivityItem {
							note
							reason {
								id
								name
							}
						}
					}
				}
			}
		}
	}
`;
